import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import LottieFileInPage from "@/app/components/lib/lottie-files/LottieFileInPage";
import { filtersAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { clearAllFilters } from "@/app/components/common-filter-builder/flters-helpers/filter-functions";
import { usePathname } from "next/navigation";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";

const EmptyProductsFilter = () => {
  const t = useTranslation();
  const pathname = usePathname();
  const router = useRouter();
  const [filtersIds, setFilterIds] = useAtom(filtersAtom);
  return (
    <LottieFileInPage
      lottieFileType={LottieFileTypes.no_result}
      title={t.no_products}
      text={t.sorry_no_products_match_this_filter}
      button={{
        onClick: () => {
          const { filterState } = clearAllFilters(filtersIds);
          setFilterIds(filterState);
          router.push(pathname);
        },
        content: <>{t.clear_filters}</>,
      }}
    />
  );
};

export default EmptyProductsFilter;
